import Homework from '@/api/eschool/homework'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  teacher_id: null,
  class_id: null,
  subject_id: null,
  homework_status_id: null,
  status_id: null,
  created_by: false
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_TEACHER_ID(state, data) {
    state.teacher_id = data
  },
  SET_CLASS_ID(state, data) {
    state.class_id = data
  },
  SET_SUBJECT_ID(state, data) {
    state.subject_id = data
  },
  SET_HOMEWORK_STATUS_ID(state, data) {
    state.homework_status_id = data
  },
  SET_HOMEWORK_STATUS(state, value) {
    state.status_id = value
  },
  SET_APPROVE_STATUS(state, data) {
    state.approve_status = data
  },
  SET_CREATED_BY(state, data) {
    state.created_by = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign({
      page: context.state.pagination.page,
      perPage: context.state.pagination.perPage,
      search: context.state.search,
      status: context.state.homework_status_id,
      filter: {
        teacher_id: context.state.teacher_id,
        class_id: context.state.class_id,
        subject_id: context.state.subject_id,
        is_sent: context.state.status_id,
        approve_status: context.state.approve_status,
        created_by: context.state.created_by
      },
      ...attributes
    })
    return Homework.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  }
}
